import { useMemo } from "react";
import { WorkItemList } from "../store/services/timelineApiRTK";
import { WORK_ITEM_CATEGORIES, WorkItemCategory } from "../utils/workItemUtils";

export const useCategoryCounts = (workItems: WorkItemList[], favorites: number[]) => {
  return useMemo(() => {
    const counts: Record<string, number> = {
      all: workItems.length,
      [WorkItemCategory.COMMUNICATION]: 0,
      [WorkItemCategory.FOLLOWUP]: 0,
      favorites: 0,
    };

    workItems.forEach((activity) => {
      Object.entries(WORK_ITEM_CATEGORIES).forEach(([category, types]) => {
        if (types.includes(activity.Type)) {
          counts[category]++;
        }
      });

      if (favorites.includes(activity.Id)) {
        counts["favorites"]++;
      }
    });

    return counts;
  }, [workItems, favorites]);
};